import { User } from './user';
import { Company } from './company';
import { CropAnalysis } from './cropAnalysis';
import { Sampling } from './sampling';
import { TenantGeneralData } from './tenantGeneralData';

export class Note extends TenantGeneralData {
  title: string;
  body: string;
  imgUrl: string;
  attachments: string[];
  lat: number;
  lng: number;
  noteDate: Date;
  user: User;
  type: string;
  damageSize: string;
  company?: Company;
  companyName?: string;
  samplings: Sampling[];
  cropAnalyses: CropAnalysis;

  constructor() {
    super();
    this.title = null;
    this.body = null;
    this.imgUrl = null;
    this.attachments = [];
    this.lat = null;
    this.lng = null;
    this.noteDate = null;
    this.user = null;
    this.type = null;
    this.damageSize = null;
    this.samplings = [];
    this.cropAnalyses = new CropAnalysis();
  }
}
/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

class Note {

    transient springSecurityService

    Long    companyId = -1
    string  title
    string  body
    string  imgUrl
    Double  lat
    Double  lng
    @BindingFormat('yyyy-MM-dd')
    Date    noteDate
    Date    dateCreated
    Date    lastUpdated
    string  damageSize


    static belongsTo = [user: User]

    static mapping = {
        autoTimestamp true
    }

    static constraints = {
        // TODO Fix beforeInsert and beforeUpdate Events Bugs and set compoanyId nullable:false
        title   blank: false
        body    blank: false, nullable: true
        imgUrl  blank: false, nullable: true, url: true
        lat     blank: false, nullable: true
        lng     blank: false, nullable: true

    }

    static transients = ['springSecurityService']

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
